import consensusAnalysisService from '../../../core/services/Fundamental/ConsensusAnalysisService';
import snapShotService from '../../../core/services/Fundamental/SnapShotService';
import priceDatService from '../../../core/services/Prices/PriceData/PriceDataService';
import { getSyncDefaultSearch } from '../../helpers/Common';
import reducerRegistry from '../../helpers/ReducerRegistry';
import { DEFAULT_CODE } from './Const';
import ConstCommon from './../../common/Const';
import currentState from './../../helpers/CurrentState';

export const REDUCER_NAME = 'FUNDAMENTAL:CONSENSUS_ANALYSIS';

export const INIT_COMPONENT = `${REDUCER_NAME}INIT_COMPONENT`;

export const UNMOUNT_COMPONENT = `${REDUCER_NAME}UNMOUNT_COMPONENT`;

const FETCH_LATEST_PRICE_SUCCESS = `${REDUCER_NAME}_FETCH_LATEST_PRICE_SUCCESS`;

export const FETCH_DATA_SUCCESS = `${REDUCER_NAME}_FETCH_DATA_SUCCESS`;

const SET_CODE = `${REDUCER_NAME}_SET_CODE`;

const FETCH_COMPANY_SCORE_SUCCESS = `${REDUCER_NAME}_FETCH_COMPANY_SCORE_SUCCESS`;

const SET_LOADING = `${REDUCER_NAME}_SET_LOADING`;

export const setLoading = (id, bool = true) => ({
  type: SET_LOADING,
  payload: {
    id,
    isLoading: bool,
  },
});

export const fetchLatestPrice = (params, id) => dispatch => {
  priceDatService.getLatestPrice(params).then(response => {
    const price = Array.isArray(response.items)
      ? response.items[0]
      : { priceInfo: {} };
    dispatch(fetchLatestPriceSuccess(price, id));
  });
};

export const fetchCompanyScore = (params, id) => dispatch => {
  snapShotService.getCompanyScore(params).then(response => {
    dispatch({
      type: FETCH_COMPANY_SCORE_SUCCESS,
      payload: {
        id,
        score: response.items && response.items[0] ? response.items[0] : {},
      },
    });
  });
};

export const fetchLatestPriceSuccess = (price, id) => ({
  type: FETCH_LATEST_PRICE_SUCCESS,
  payload: {
    id,
    price: price.priceInfo,
  },
});

export const fetchData = (params, id) => dispatch => {
  dispatch(setLoading(id));
  consensusAnalysisService.getConsensus(params).then(response => {
    dispatch({
      type: FETCH_DATA_SUCCESS,
      payload: {
        id,
        data:
          response.items && response.items[0]
            ? response.items[0]
            : {
                targetPrice: {},
                targetPriceHistories: [],
                recommendations: [],
                recommendationHistories: [],
              },
      },
    });
  });
};

export const setCode = (payload, id) => ({
  type: SET_CODE,
  payload: {
    id,
    data: payload,
  },
});

const initialState = {};

const reducer = (state = {}, action) => {
  switch (action.type) {
    case INIT_COMPONENT:
      const { id, dragCode } = action.payload;

      return {
        ...state,
        ...initialState,
        [id]: {
          currentSearch: dragCode ||
            currentState.get(
              ConstCommon.listComponent.ConsensusAnalysis,
              'currentSearch',
              id,
            ) ||
            getSyncDefaultSearch(
              ConstCommon.listComponent.ConsensusAnalysis,
              true,
            ) || {
              code: DEFAULT_CODE,
              displayCode: DEFAULT_CODE,
            },
          latestPrice: {},
          isLoading: true,
          score: {},
        },
      };
    case UNMOUNT_COMPONENT:
      const { [action.payload.id]: _, ...rest } = state;

      return rest;

    case FETCH_LATEST_PRICE_SUCCESS:
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          latestPrice: action.payload.price,
        },
      };

    case FETCH_COMPANY_SCORE_SUCCESS:
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          score: action.payload.score,
        },
      };
    case SET_CODE:
      const { code, displayCode } = action.payload.data;

      currentState.add(
        ConstCommon.listComponent.ConsensusAnalysis,
        'currentSearch',
        { code, displayCode },
        action.payload.id,
      );

      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          currentSearch: action.payload.data,
        },
      };
    case FETCH_DATA_SUCCESS:
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          ...action.payload.data,
          isLoading: false,
        },
      };
    case SET_LOADING:
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          isLoading: true,
        },
      };
    default:
      return state;
  }
};

reducerRegistry.register(REDUCER_NAME, reducer);
